"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTransform_1 = require("./BaseTransform");

var Query_1 = require("../Query");

var number_1 = require("../../utils/number");

var NumberTransform =
/** @class */
function (_super) {
  __extends(NumberTransform, _super);

  function NumberTransform() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  NumberTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
    if (queryResponse && number_1.isNumber(queryResponse)) {
      var numberOptions = this.options.numberOptions;

      if (numberOptions && numberOptions.operator && numberOptions.valueQuery) {
        var valueQuery = new Query_1.Query(numberOptions.valueQuery);
        var value = valueQuery.execute(executionOptions);

        switch (numberOptions.operator) {
          case 'multiply':
            return queryResponse * value;

          case 'divide':
            return queryResponse / value;

          case 'add':
            return queryResponse + value;

          case 'subtract':
            return queryResponse - value;

          default:
            return queryResponse;
        }
      }
    }

    return queryResponse;
  };

  return NumberTransform;
}(BaseTransform_1.BaseTransform);

exports.NumberTransform = NumberTransform;